<template>
  <el-container class="account-container">
    <el-header class="header__nav">
      <accountManagerHeader></accountManagerHeader>
    </el-header>
    <router-view></router-view>
  </el-container>
</template>

<script>
import accountManagerHeader from "@/components/accountManager/accountManagerHeader";
export default {
  components: {
    accountManagerHeader
  }
};
</script>

<style lang="scss">
.account-container {
  display: block;
  $header-height: 40px;
  $navigation-width-onopen: 200px;
  $navigation-width-onclose: 64px;
  box-sizing: border-box;
  //   height: 100vh;
  overflow: hidden;
  .header__nav {
    height: $header-height !important;
    position: relative;
    border-bottom: 1px solid #dcdfe6;
    top: 0px;
    left: 0px;
    right: 0px;
  }
  .header--padding {
    margin-left: 100px;
    margin-right: 100px;
  }
  .el-header {
    padding: 0px 10px;
  }
}
</style>